import Axios from 'axios';

import {
	DEFERRED_QUEUES_LOADING,
	DEFERRED_QUEUES_GET,
	DEFERRED_QUEUES_ERROR,
	DEFERRED_ELEMENTS_LOADING,
	DEFERRED_ELEMENTS_GET,
	DEFERRED_ELEMENTS_ERROR,
	DEFERRED_COUNT_GET,
	DEFERRED_COUNT_ERROR
} from './types';

import { alert_remove, alert_set } from './alertActions';

import create_query_params from '../utils/create_query_params';

export const get_deferred_queues = (filters = {}) => dispatch => {
	dispatch({ type: DEFERRED_QUEUES_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred?';
	url += create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		dispatch({ type: DEFERRED_QUEUES_GET, payload: res.data });
		dispatch({ type: DEFERRED_QUEUES_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: DEFERRED_QUEUES_ERROR, payload: { type: 'deferred_queues', msg: err.message } });
		dispatch({ type: DEFERRED_QUEUES_LOADING, payload: false });
	})
}

export const get_deferred_elements = (filters = {}) => dispatch => {
	dispatch({ type: DEFERRED_ELEMENTS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred/elements?';
	url += create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		let result = res.data;
		if (result.elements) {
			result.elements = result.elements.map((element) => typeof element === 'string' ? JSON.parse(element) : element);
		}

		dispatch({ type: DEFERRED_ELEMENTS_GET, payload: result });
		dispatch({ type: DEFERRED_ELEMENTS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: DEFERRED_ELEMENTS_ERROR, payload: { type: 'deferred_elements', msg: err.message } });
		dispatch({ type: DEFERRED_ELEMENTS_LOADING, payload: false });
	})
}

export const get_deferred_count = (filters = {}) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred/count?';
	url += create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		dispatch({ type: DEFERRED_COUNT_GET, payload: res.data });
	}).catch((err) => {
		dispatch({ type: DEFERRED_COUNT_ERROR, payload: { type: 'deferred_count', msg: err.message } });
	})
}

export const retry_deferred = (filters = {}) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred/retry?';
	url += create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		dispatch(alert_set('#0d6efd', 'info', `Job retried from deferred queue.`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	}).catch((err) => {
		dispatch(alert_set('#dc3545', 'danger', `Failed to retry deferred job. ${err.message}`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	})
}

export const retry_all_deferred = (filters = {}) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred/retry/all?';
	url += create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		dispatch(alert_set('#0d6efd', 'info', `Retrying all deferred jobs. ${res.data.retried ? res.data.retried + ' jobs retried.' : ''}`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	}).catch((err) => {
		dispatch(alert_set('#dc3545', 'danger', `Failed to retry all deferred jobs. ${err.message}`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	})
}

export const remove_deferred = (filters = {}) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/workers/deferred/remove?';
	url += create_query_params(filters);

	Axios.delete(url)
	.then((res) => {
		dispatch(alert_set('#fd7e14', 'success', `Deferred jobs removed.`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	}).catch((err) => {
		dispatch(alert_set('#dc3545', 'danger', `Failed to remove deferred jobs. ${err.message}`));
		setTimeout(() => { dispatch(alert_remove()); }, 4000);
	})
}
